export const ApplicationType = {
  NEW_ACCOUNT: 'NEW_ACCOUNT',
  LIMIT_INCREASE: 'LIMIT_INCREASE',
}
